/**
 * アクティビティ見直し進捗用Zustandストア
 *
 * 「この日まで見直し済み」の水位線を保持する。
 * フルアクセス権限を持つユーザーのみ使用可能
 */

import { create } from 'zustand'

import { getActivityReviewProgress, updateActivityReviewProgress } from '@/api/services/activity-review'

type ActivityReviewState = {
  /** この日まで見直し済み（YYYY-MM-DD）。未設定なら null */
  reviewedThroughDate: string | null
  unreviewedDays: number
  isLoading: boolean
  isFetched: boolean

  fetchProgress: () => Promise<void>
  /** 見直し済みの日付を更新（成功時 true） */
  setReviewedThrough: (date: string) => Promise<boolean>
}

export const useActivityReviewStore = create<ActivityReviewState>((set, get) => ({
  reviewedThroughDate: null,
  unreviewedDays: 0,
  isLoading: false,
  isFetched: false,

  fetchProgress: async () => {
    if (get().isLoading) return
    set({ isLoading: true })
    try {
      const progress = await getActivityReviewProgress()
      set({
        reviewedThroughDate: progress.reviewed_through_date,
        unreviewedDays: progress.unreviewed_days,
        isFetched: true,
      })
    } catch {
      set({ isFetched: true })
    } finally {
      set({ isLoading: false })
    }
  },

  setReviewedThrough: async (date: string) => {
    try {
      const progress = await updateActivityReviewProgress(date)
      set({
        reviewedThroughDate: progress.reviewed_through_date,
        unreviewedDays: progress.unreviewed_days,
      })
      return true
    } catch {
      return false
    }
  },
}))
